export default __webpack_public_path__ + "static/media/cexplorer-logo-extend.3f517703.svg";